interface ConvertedMinutes {
  days: number;
  hours: number;
  minutes: number;
}

const empty: ConvertedMinutes = {
  days: 0,
  hours: 0,
  minutes: 0,
};

const convertMinutes = (inputMinutes?: number | null): ConvertedMinutes => {
  if (!inputMinutes) return empty;

  // Calculate the number of days
  const days: number = Math.floor(inputMinutes / 1440);

  // Calculate the number of hours
  const hours: number = Math.floor((inputMinutes % 1440) / 60);

  // Calculate the number of minutes
  const minutes: number = inputMinutes % 60;

  return {
    days,
    hours,
    minutes,
  };
};

export default convertMinutes;
